import React from "react";

import { Fab, Tooltip } from "@mui/material";
import { Fragment } from "react";
import AddIcon from "@mui/icons-material/AddTwoTone";

const TooltipAddComponent = ({
    handleClickOpenDialog = () => { },
    open,
    title,
    children
}) => {


    return (
        <Fragment>
            <Tooltip title={title}>
                <Fab
                    color="primary"
                    onClick={handleClickOpenDialog}
                    sx={{
                        boxShadow: "none",
                        ml: 1,
                        width: 40,
                        height: 40,
                        minHeight: 32,
                        zIndex: 0
                    }}
                >
                    <AddIcon />
                </Fab>
            </Tooltip>
            {open &&
                <Fragment>
                    {children}
                </Fragment>
            }
        </Fragment>
    );
};


export default TooltipAddComponent;
